import {
  FILLER_WORDS_FEEDBACK,
  FILLER_WORDS_OPTIONS,
  FILLER_WORDS_QUESTION,
} from '~/pages/communication/fillerWords/libs/components/FillerWordsCommunication/constants'
import FeedbackQuestionPage from '~/pages/communication/libs/FeedbackQuestionPage'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTION_I18N_PREFIX = 'onboarding.communicationFiller.options'
const TITLE_I18N_KEY = 'onboarding.communicationFiller.title'

const FillerWordsCommunication = (props: TPageProps) => (
  <FeedbackQuestionPage
    {...props}
    question={FILLER_WORDS_QUESTION}
    titleI18nKey={TITLE_I18N_KEY}
    optionI18nKeyPrefix={OPTION_I18N_PREFIX}
    options={FILLER_WORDS_OPTIONS}
    feedback={FILLER_WORDS_FEEDBACK}
  />
)

export default FillerWordsCommunication
